function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 34 34",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M31.63 27.49a2.9 2.9 0 01-.1 3.02C30.9 31.5 30 32 28.84 32H5.14c-1.15 0-2.04-.5-2.67-1.5a3.05 3.05 0 01-.14-3.01L14.2 3.74A2.97 2.97 0 0116.99 2c1.3 0 2.23.58 2.78 1.74zm-16.5-17.36v10.62h3.74V10.12zM17 28.86a2.4 2.4 0 001.76-.73 2.41 2.41 0 00.73-1.77c0-.69-.24-1.28-.73-1.77a2.4 2.4 0 00-1.76-.73c-.7 0-1.29.25-1.77.73a2.41 2.41 0 00-.73 1.77c0 .7.24 1.29.73 1.77a2.4 2.4 0 001.77.73z"
})));